<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="课程名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="封面上传" prop="cover">
            <imgUpload v-model="ruleForm.cover"> </imgUpload>
          </el-form-item>
          <el-form-item label="课程类别" prop="cate">
            <!-- <el-tag>+</el-tag> -->
            <el-select v-model="ruleForm.cate" multiple style="width: 100%">
              <el-option v-for="item in typeList" :label="item.title" :value="item.uuid">{{ item.title }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任老师" prop="duty_teacher">
            <el-select
              v-model="ruleForm.duty_teacher"
              filterable
              remote
              reserve-keyword
              multiple
              placeholder="请输入关键词"
              :remote-method="getTeacherDuty"
              :loading="loading"
              style="width: 100%"
            >
              <el-option disabled="disabled" label="1" value="1">
                <div class="option">
                  <span>老师昵称</span>
                  <span>手机号</span>
                </div>
              </el-option>
              <el-option v-for="item in teacherListDuty" :key="item.uuid" :label="item.name" :value="item.uuid">
                <div class="option">
                  <span>{{ item.name }}</span>
                  <span>{{ item.mobile }}</span>
                </div>
              </el-option>
            </el-select>
            <!-- <el-select v-model="ruleForm.teacher_uuid" multiple>
                            <el-option v-for="item in teacherList" :label="item.name" :value="item.uuid"></el-option>

                        </el-select> -->
          </el-form-item>
          <el-form-item label="授课老师" prop="teacher_uuid">
            <el-select
              v-model="ruleForm.teacher_uuid"
              filterable
              remote
              reserve-keyword
              multiple
              placeholder="请输入关键词"
              :remote-method="getTeacher"
              :loading="loading"
              style="width: 100%"
            >
              <el-option disabled="disabled" label="1" value="1">
                <div class="option">
                  <span>老师昵称</span>
                  <span>手机号</span>
                </div>
              </el-option>
              <el-option v-for="item in teacherList" :key="item.uuid" :label="item.name" :value="item.uuid">
                <div class="option">
                  <span>{{ item.name }}</span>
                  <span>{{ item.mobile }}</span>
                </div>
              </el-option>
            </el-select>
            <!-- <el-select v-model="ruleForm.teacher_uuid" multiple>
                            <el-option v-for="item in teacherList" :label="item.name" :value="item.uuid"></el-option>

                        </el-select> -->
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="展示价格" prop="original_price">
                <el-input v-model="ruleForm.original_price">
                  <span slot="prefix">￥</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存" prop="stock">
                <el-input-number v-model="ruleForm.stock" :min="0" :max="10000" label="库存"></el-input-number>
                <!-- <el-input v-model="ruleForm.stock"></el-input> -->
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="支付价">
            <el-row style="margin-bottom: 20px">
              <el-col :span="12">
                <el-form-item label="高级" prop="high_price">
                  <el-input v-model="ruleForm.high_price">
                    <span slot="prefix">￥</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="中级" prop="middle_price">
                  <el-input v-model="ruleForm.middle_price">
                    <span slot="prefix">￥</span>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-col :span="12">
              <el-form-item label="初级" prop="primary_price">
                <el-input v-model="ruleForm.primary_price">
                  <span slot="prefix">￥</span>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="普通" prop="common_price">
                <el-input v-model="ruleForm.common_price">
                  <span slot="prefix">￥</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="别名">
            <el-row style="margin-bottom: 20px">
              <el-col :span="12">
                <el-form-item label="高级别名" prop="high_alias">
                  <el-input v-model="ruleForm.high_alias"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="中级别名" prop="middle_alias">
                  <el-input v-model="ruleForm.middle_alias"> </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-col :span="12">
              <el-form-item label="初级别名" prop="primary_alias">
                <el-input v-model="ruleForm.primary_alias"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="普通别名" prop="common_alias">
                <el-input v-model="ruleForm.common_alias"> </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="原价" prop="original_price">
                        <el-input v-model="ruleForm.original_price">
                            <span slot="prefix">￥</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="库存" prop="stock">
                        <el-input-number v-model="ruleForm.stock" :min="0" :max="10000" label="库存"></el-input-number>

                    </el-form-item> -->
        </el-col>

        <el-col :span="12">
          <el-form-item label="轮播图上传" prop="banner">
            <imgUploads v-model="ruleForm.banner" component-id="'img" :limit="8"></imgUploads>
          </el-form-item>
          <!-- <el-form-item label="师资力量上传" prop="faculty">
                        <imgUploads v-model="ruleForm.faculty" component-id="imga" :limit="8"></imgUploads>

                    </el-form-item> -->
          <el-form-item label="场地介绍上传" prop="venues">
            <imgUploads v-model="ruleForm.venues" component-id="imgc" :limit="8"></imgUploads>
          </el-form-item>
          <!-- <el-form-item label="合作机构上传" prop="partners">
                        <imgUploads v-model="ruleForm.partners" component-id="imgd" :limit="8"></imgUploads>

                    </el-form-item> -->
        </el-col>
      </el-row>
      <el-form-item label="课程简介" prop="detail">
        <fullEdit v-model="ruleForm.detail"></fullEdit>
      </el-form-item>
      <el-dialog title="添加课节" :visible.sync="sectionBox" center>
        <addSection
          v-if="sectionBox"
          ref="addSection"
          @closeBox="sectionBox = false"
          @subForm="changSection"
          @getList="getSectionList"
        >
        </addSection>
      </el-dialog>
      <el-form-item label="课程章节" prop="section">
        <el-tag @click="showSection">+</el-tag>

        <table border="1" cellpadding="0" cellspacing="0" class="table">
          <tr>
            <th>一级目录</th>
            <th>排序</th>
            <th>课节名称</th>
            <th>课节</th>
            <th>上课方式</th>
            <th>课程类型</th>
            <th>视频</th>
            <th>上课时间</th>
            <th>小结测试</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, i) in ruleForm.section">
            <td>
              {{ ["", "普通课程", "初级课程", "中级课程", "高级课程"][item.catalogue] }}
            </td>
            <td>{{ item.list_order }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.count }}</td>
            <td>
              <span v-if="item.class_model === 1">线上</span>
              <span v-if="item.class_model === 2">线下</span>
              <span v-if="item.class_model === 3">直播</span>
            </td>
            <td>{{ item.type == 1 ? "理论课" : "线下" }}</td>
            <td>
              <video v-if="item.vedio" :src="item.vedio" controls="controls"></video>
              <span v-else>暂无</span>
            </td>
            <td>
              <el-popover placement="top-start" title="上课时间" width="200" trigger="hover">
                <p v-if="item.class_info">
                  {{
                    JSON.parse(item.class_info)
                      .map((it) => {
                        return "地点：" + it.lession_address + "  时间：" + it.lession_time;
                      })
                      .join(",")
                  }}
                </p>
                <i v-if="item.class_model == 2" slot="reference" class="el-icon-zoom-in">查看</i>
              </el-popover>
            </td>
            <td>{{ item.paper_name }}</td>
            <td>
              <el-button class="mid-blue" @click="editSection(item, i)">编辑</el-button>
              <el-button class="mid-red" @click="delSection(i)">删除</el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item label="报名条件" prop="problem">
        <p>硬性条件</p>

        <el-row>
          <el-col :span="5" style="white-space: nowrap">
            <el-form-item label="工作经验不小于" prop="experience" label-width="120px">
              <el-input v-model="ruleForm.experience">
                <span slot="suffix"> 年</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="健康状况" prop="healthy">
              <el-select v-model="ruleForm.healthy">
                <el-option label="不限" :value="1"></el-option>
                <el-option label="健康" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="学历不低于" prop="education">
              <el-select v-model="ruleForm.education">
                <el-option label="不限" :value="1"></el-option>
                <el-option label="初中" :value="2"></el-option>
                <el-option label="高中" :value="3"></el-option>
                <el-option label="专科" :value="4"></el-option>
                <el-option label="本科" :value="5"></el-option>
                <el-option label="硕士" :value="6"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="性别要求" prop="sex">
              <el-select v-model="ruleForm.sex">
                <el-option label="不限" :value="1"></el-option>
                <el-option label="男" :value="2"></el-option>
                <el-option label="女" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="结束时间" prop="bm_end_time">
              <el-date-picker
                v-model="ruleForm.bm_end_time"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <p>
          <span style="color: red">*</span>其它条件
          <el-tag type="danger" @click="conditionBox = true">+</el-tag>
        </p>

        <table border="1" cellpadding="0" cellspacing="0" class="table">
          <tr>
            <th>序号</th>
            <th>问题</th>
            <th>选项A</th>
            <th>允许报名</th>
            <th>选项B</th>
            <th>不允许报名</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, i) in ruleForm.problem">
            <td>{{ i + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.option_A }}</td>
            <td>{{ getName(item.allow) }}</td>
            <td>{{ item.option_B }}</td>
            <td>{{ getName(item.not_allow) }}</td>

            <td>
              <el-button class="mid-blue" @click="editCondition(item, i)">编辑</el-button>
              <el-button class="mid-red" @click="delCondition(i)">删除</el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-dialog title="添加条件" :visible.sync="conditionBox" center>
        <add-condition
          v-if="conditionBox"
          ref="addCondition"
          @closeBox="conditionBox = false"
          @saveForm="changeCondition"
          @getList="getConditionList"
        ></add-condition>
      </el-dialog>
      <el-form-item label="关联终考" prop="final_exam">
        <el-select
          v-model="final_exam"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="getPaperList"
          :loading="loading"
          @change="getFinal"
        >
          <el-option disabled="disabled" label="1" value="1">
            <div class="option">
              <span>试卷名称</span>
            </div>
          </el-option>
          <el-option v-for="item in paper_list" :key="item.uuid" :label="item.title" :value="item.uuid">
            <div class="option">
              <span>{{ item.title }}</span>
            </div>
          </el-option>
        </el-select>
        <table border="1" cellpadding="0" cellspacing="0" class="table">
          <tr>
            <th>一级目录</th>
            <th>考卷名称</th>
            <th>考试方式</th>
            <th>考试类型</th>

            <th>操作</th>
          </tr>
          <tr v-for="(item, i) in final_list">
            <td>
              <el-select v-model="item.catalogue" @change="$forceUpdate()">
                <el-option label="普通课程" :value="1" :disabled="notIn(1)"></el-option>
                <el-option label="初级课程" :value="2" :disabled="notIn(2)"></el-option>
                <el-option label="中级课程" :value="3" :disabled="notIn(3)"></el-option>
                <el-option label="高级课程" :value="4" :disabled="notIn(4)"></el-option>
              </el-select>
            </td>
            <td>{{ item.title }}</td>

            <td>{{ item.exam_type == 1 ? "线上" : "线下" }}</td>
            <td>{{ item.paper_type == 1 ? "理论课" : "线下" }}</td>

            <td>
              <el-button class="mid-red" @click="delFinal(i)">删除</el-button>
            </td>
          </tr>
        </table>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import addSection from "./component/addSection.vue";
import addCondition from "./component/addCondition.vue";
import {
  addCouse,
  conditionList,
  sectionList,
  delSection,
  sectionDetail,
  conditionDetail,
  delCondition,
  paperList,
  editCouse,
  couseDetail,
} from "@/api/edu.js";
import { getLiveType, addLive, getLiveDetail, editLive } from "@/api/live.js";
import { getTeacherList } from "@/api/teacher.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
    addSection,
    addCondition,
  },
  data() {
    return {
      final_exam: [],
      query: {},
      paper_list: [],
      sectionBox: false,
      conditionBox: false,
      dates: [],
      loading: false,
      typeList: [],
      captureList: [],
      conditionList: [],
      teacherList: [],
      teacherListDuty: [],
      final_list: [],
      ruleForm: {
        teacher_uuid: [],
        duty_teacher: [],
        cate: [],
        problem: [],
        section: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传课程封面",
            trigger: "change",
          },
        ],
        banner: [
          {
            required: true,
            message: "请上传课程封面",
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入现价",
            trigger: "blur",
          },
        ],
        high_price: [
          {
            required: false,
            message: "请输入高级课程支付价",
            trigger: "blur",
          },
        ],
        middle_price: [
          {
            required: false,
            message: "请输入中级课程支付价",
            trigger: "blur",
          },
        ],
        primary_price: [
          {
            required: false,
            message: "请输入初级课程支付价",
            trigger: "blur",
          },
        ],
        common_price: [
          {
            required: false,
            message: "请输入普通课程支付价",
            trigger: "blur",
          },
        ],
        original_price: [
          {
            required: true,
            message: "请输入原价",
            trigger: "blur",
          },
        ],
        stock: [
          {
            required: true,
            message: "请输入库存",
            trigger: "change",
          },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        cate: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个类别",
            trigger: "change",
          },
        ],
        duty_teacher: [
          {
            required: true,
            message: "请选择责任老师",
            trigger: "change",
          },
        ],
        teacher_uuid: [
          {
            required: true,
            message: "请选择授课老师",
            trigger: "change",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入课程简介",
            trigger: "blur",
          },
        ],
        experience: [
          {
            required: false,
            message: "请输入工作经验",
            trigger: "blur",
          },
        ],
        problem: [
          {
            required: false,
            message: "请输入其它条件 ",
            trigger: "change",
          },
        ],
        healthy: [
          {
            required: false,
            message: "请选择健康状况",
            trigger: "change",
          },
        ],
        education: [
          {
            required: false,
            message: "请选择学历",
            trigger: "change",
          },
        ],
        sex: [
          {
            required: false,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        bm_end_time: [
          {
            required: false,
            message: "请选择结束时间",
            trigger: "change",
          },
        ],
        section: [
          {
            required: true,
            message: "请添加章节",
            trigger: "change",
          },
        ],
        high_alias: [
          {
            required: true,
            message: "请添加高级别名",
            trigger: "change",
          },
        ],
        middle_alias: [
          {
            required: true,
            message: "请添加中级别名",
            trigger: "change",
          },
        ],
        primary_alias: [
          {
            required: true,
            message: "请添加初级别名",
            trigger: "change",
          },
        ],
        common_alias: [
          {
            required: true,
            message: "请添加普通别名",
            trigger: "change",
          },
        ],
        // final_exam: [{
        //     required: true,
        //     message: '请添加关联终考',
        //     trigger: 'change'
        // }]
      },
    };
  },
  mounted() {
    console.log();
    const row = this.$route.query;
    this.query = row;
    if (row.uuid) {
      this.getDetail(row);
    }
    // this.getSectionList()
    this.getType();
    this.getTeacher("");
    this.getTeacherDuty("");
    // this.getConditionList()

    this.getPaperList("");
  },
  methods: {
    getName(types) {
      const arr = ["", "普通课程", "初级课程", "中级课程", "高级课程"];
      if (Array.isArray(types)) {
        return types
          .map((it) => {
            return arr[it];
          })
          .join(",");
      }
    },
    changeCondition(val) {
      if (this.ruleForm.problem instanceof Array) {
      } else {
        this.ruleForm.problem = [];
      }
      if (val.editId) {
        const eid = val.editId;
        delete val.editId;
        this.ruleForm.problem[eid] = val;
        // const ind = this.ruleForm.problem.findIndex(it => { return it.uuid == val.uuid })
        // if (ind > -1) {
        //     this.ruleForm.problem[ind] = val
        // }
      } else {
        this.ruleForm.problem.push(val);
      }
    },
    changSection(val) {
      if (val.class_info) {
        val.class_info = JSON.stringify(val.class_info);
      }
      if (val.vedio) {
        val.vedio = val.vedio.join(",");
      }
      if (this.ruleForm.section instanceof Array) {
      } else {
        this.ruleForm.section = [];
      }
      if (val.editId) {
        const eid = val.editId;
        delete val.editId;
        this.ruleForm.section[eid] = val;
        // const ind = this.ruleForm.section.findIndex(it => { return it.uuid == val.uuid })
        // if (ind > -1) {
        //     this.ruleForm.section[ind] = val
        // }
      } else {
        this.ruleForm.section.push(val);
      }
      this.ruleForm.section.sort((a, b) => {
        return b.catalogue - a.catalogue;
      });
    },
    notIn(i) {
      const list = this.final_list.map((it) => {
        return it.catalogue;
      });
      return list.includes(i);
    },
    getFinal(val) {
      console.log(val);
      const item = this.paper_list.find((item) => {
        return item.uuid == val;
      });
      const iii = [1, 2, 3, 4].find((mi) => {
        // console.log(this.notIn(mi))
        return !this.notIn(mi);
      });
      item.catalogue = iii;
      item.class_model = item.exam_type;
      const index = this.final_list.findIndex((mi) => {
        return mi.uuid == item.uuid;
      });
      if (index == -1) {
        if (this.final_list.length >= 4) {
          this.$message.info("添加的终考已达上限");
          return;
        }
        this.final_list.push(item);
      }
    },
    delFinal(i) {
      this.final_list.splice(i, 1);
    },
    getPaperList(keyword_search) {
      paperList({
        keyword_search,
        paper_type: 2,
        status: 2,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.paper_list = res.data;
        }
      });
    },
    getConditionList() {
      conditionList({ course_uuid: this.query.uuid }).then((res) => {
        if (Array.isArray(res.data)) {
          this.conditionList = res.data;
        }
      });
    },
    editCondition(row, i) {
      this.conditionBox = true;
      row.editId = i + "";
      this.$nextTick(() => {
        this.$refs.addCondition.initData(row);
      });
      // conditionDetail(row.uuid).then(res => {
      //     if (res) {
      //         console.log(res)
      //         this.conditionBox = true
      //         this.$nextTick(() => {
      //             this.$refs.addCondition.initData(row)
      //         })
      //     }
      // })
    },
    delCondition(ind) {
      this.ruleForm.problem.splice(ind, 1);
      // this.$confirm('确定要删除该条件吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      // }).then(() => {
      //     delCondition(row.uuid).then(res => {
      //         if (res) {
      //             this.$message.success('成功')
      //             this.getConditionList()
      //         }
      //     })
      // }).catch(() => {
      //     this.$message({
      //         type: 'info',
      //         message: '已取消删除'
      //     });
      // });
    },
    getSectionList() {
      sectionList({ course_uuid: this.query.uuid }).then((res) => {
        if (Array.isArray(res.data)) {
          this.captureList = res.data;
        }
      });
    },
    delSection(ind) {
      this.ruleForm.section.splice(ind, 1);
      return;
      this.$confirm("确定要删除该章节吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSection(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getSectionList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    showSection() {
      this.sectionBox = true;
      // this.$nextTick(() => {
      //     this.$refs.addSection.getPaperList('')
      // })
    },
    editSection(row, i) {
      this.sectionBox = true;
      row.editId = i + "";
      this.$nextTick(() => {
        this.$refs.addSection.initData(row);
      });
      // sectionDetail(row.uuid).then(res => {
      //     if (res) {
      //         console.log(res)
      //         this.sectionBox = true
      //         this.$nextTick(() => {
      //             this.$refs.addSection.initData(row)
      //         })
      //     }
      // })
    },
    async getDetail(row) {
      const res = await couseDetail(row.uuid);

      if (res) {
        if (res.cate instanceof Array) {
          const cate = res.cate.filter((it) => {
            return it.status == 2;
          });
          res.cate = cate.map((it) => {
            return it.uuid;
          });
        }
        if (res.final_exam instanceof Array) {
          this.final_list = res.final_exam.map((item) => {
            return { catalogue: item.catalogue, ...item.paper };
          });
        }
        if (res.duty_teacher instanceof Array) {
          res.duty_teacher = res.duty_teacher.map((item) => {
            return item.uuid;
          });
        }
        if (res.teacher_uuid instanceof Array) {
          res.teacher_uuid = res.teacher_uuid.map((item) => {
            return item.uuid;
          });
        }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        if (res.section instanceof Array) {
          res.section.sort((a, b) => {
            return b.catalogue - a.catalogue;
          });
        }
        this.ruleForm = {
          ...res,
        };
        console.log(res);
      }
    },
    getType() {
      getLiveType({ status: 2 }).then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({
        keyword_search,
        type: 1, // 授课
      }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    getTeacherDuty(keyword_search) {
      getTeacherList({
        keyword_search,
        type: 2, // 责任
      }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherListDuty = res.data;
        }
      });
    },
    editSave(data, uuid) {
      editCouse(data, uuid).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("编辑成功");

          this.$router.go(-1);
        }
      });
    },
    addSave(data) {
      addCouse(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("新增成功");

          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            price: this.ruleForm.original_price,
            // section: this.captureList.map(item => item.uuid),
            // problem: this.conditionList.map(item => item.uuid),
            final_exam: this.final_list.map((item) => {
              return {
                paper_uuid: item.uuid,
                type: item.type,
                catalogue: item.catalogue,
                class_model: item.exam_type,
              };
            }),
          };
          if (this.ruleForm.uuid) {
            this.editSave(data, this.ruleForm.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}

.table {
  width: 100%;
  table-layout: fixed;
  text-align: center;
  border-color: #eee;
  td {
  }
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
